import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import { makeMainRoutes } from './routes';
import { loadSsoConnections } from './Auth/ssoConnectionsLoader';

// Pull the latest SSO tenant config from the server (MongoDB-backed) before the
// login flow runs. Fire-and-forget: AUTH_CONFIG.ssoConnections holds hardcoded
// fallback values until this resolves, so login routing works regardless.
loadSsoConnections();

const routes = makeMainRoutes();
createRoot(document.getElementById('root')).render(routes);
